/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SearchRouteImport } from './routes/search'
import { Route as FeaturedRouteImport } from './routes/featured'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as onboardingRouteRouteImport } from './routes/(onboarding)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as UsersIdRouteImport } from './routes/users.$id'
import { Route as SettingsWalletRouteImport } from './routes/settings/wallet'
import { Route as SettingsFeedbackRouteImport } from './routes/settings/feedback'
import { Route as SettingsDashboardRouteImport } from './routes/settings/dashboard'
import { Route as SettingsContactSupportRouteImport } from './routes/settings/contact-support'
import { Route as SettingsBlockedUsersRouteImport } from './routes/settings/blocked-users'
import { Route as SettingsArchiveRouteImport } from './routes/settings/archive'
import { Route as ProfilesIdRouteImport } from './routes/profiles.$id'
import { Route as ProductsIdRouteImport } from './routes/products.$id'
import { Route as LooksCreateRouteImport } from './routes/looks.create'
import { Route as LooksIdRouteImport } from './routes/looks.$id'
import { Route as CollectionsIdRouteImport } from './routes/collections.$id'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminPendingUsersRouteImport } from './routes/admin/pending-users'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as onboardingauthRouteRouteImport } from './routes/(onboarding)/(auth)/route'
import { Route as SettingsAccountIndexRouteImport } from './routes/settings/account/index'
import { Route as SettingsSubscriptionsPriceRouteImport } from './routes/settings/subscriptions/price'
import { Route as SettingsSubscriptionsManageRouteImport } from './routes/settings/subscriptions/manage'
import { Route as SettingsAccountChangePasswordRouteImport } from './routes/settings/account/change-password'
import { Route as ProfilesIdSubscribersRouteImport } from './routes/profiles_.$id.subscribers'
import { Route as ProfilesIdFollowingRouteImport } from './routes/profiles_.$id.following'
import { Route as LooksIdEditRouteImport } from './routes/looks_.$id.edit'
import { Route as CollectionsIdEditDetailsRouteImport } from './routes/collections_.$id.edit-details'
import { Route as CollectionsIdEditRouteImport } from './routes/collections_.$id.edit'
import { Route as onboardingpricingPricingRouteImport } from './routes/(onboarding)/(pricing)/pricing'
import { Route as onboardingpricingCheckoutReturnRouteImport } from './routes/(onboarding)/(pricing)/checkout-return'
import { Route as onboardingpricingCheckoutRouteImport } from './routes/(onboarding)/(pricing)/checkout'
import { Route as onboardingdocumentsTermsOfUseRouteImport } from './routes/(onboarding)/(documents)/terms-of-use'
import { Route as onboardingdocumentsTermsAndConditionsRouteImport } from './routes/(onboarding)/(documents)/terms-and-conditions'
import { Route as onboardingdocumentsSitemapRouteImport } from './routes/(onboarding)/(documents)/sitemap'
import { Route as onboardingdocumentsPrivacyPolicyRouteImport } from './routes/(onboarding)/(documents)/privacy-policy'
import { Route as onboardingdocumentsExtensionPrivacyPolicyRouteImport } from './routes/(onboarding)/(documents)/extension-privacy-policy'
import { Route as onboardingauthVerifyEmailRouteImport } from './routes/(onboarding)/(auth)/verify-email'
import { Route as onboardingauthResetPasswordRouteImport } from './routes/(onboarding)/(auth)/reset-password'
import { Route as onboardingauthOnboardingRouteImport } from './routes/(onboarding)/(auth)/onboarding'
import { Route as onboardingauthLogoutRouteImport } from './routes/(onboarding)/(auth)/logout'
import { Route as onboardingauthLoginRouteImport } from './routes/(onboarding)/(auth)/login'
import { Route as onboardingauthForgotPasswordRouteImport } from './routes/(onboarding)/(auth)/forgot-password_'
import { Route as onboardingauthActionRouteImport } from './routes/(onboarding)/(auth)/action'
import { Route as onboardingauthRegisterIndexRouteImport } from './routes/(onboarding)/(auth)/register/index'
import { Route as onboardingauthRegisterUsernameRouteImport } from './routes/(onboarding)/(auth)/register/username'
import { Route as onboardingauthRegisterPreferencesRouteImport } from './routes/(onboarding)/(auth)/register/preferences'
import { Route as onboardingauthRegisterInstagramRouteImport } from './routes/(onboarding)/(auth)/register/instagram'
import { Route as onboardingauthRegisterAccountTypeRouteImport } from './routes/(onboarding)/(auth)/register/account-type'
import { Route as onboardingauthForgotPasswordSentRouteImport } from './routes/(onboarding)/(auth)/forgot-password.sent'
import { Route as onboardingauthextensionExtensionAuthCheckRouteImport } from './routes/(onboarding)/(auth)/(extension)/extension-auth-check'
import { Route as onboardingauthextensionExtensionAuthCallbackRouteImport } from './routes/(onboarding)/(auth)/(extension)/extension-auth-callback'

const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturedRoute = FeaturedRouteImport.update({
  id: '/featured',
  path: '/featured',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const onboardingRouteRoute = onboardingRouteRouteImport.update({
  id: '/(onboarding)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const UsersIdRoute = UsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsWalletRoute = SettingsWalletRouteImport.update({
  id: '/settings/wallet',
  path: '/settings/wallet',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsFeedbackRoute = SettingsFeedbackRouteImport.update({
  id: '/settings/feedback',
  path: '/settings/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsDashboardRoute = SettingsDashboardRouteImport.update({
  id: '/settings/dashboard',
  path: '/settings/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsContactSupportRoute = SettingsContactSupportRouteImport.update({
  id: '/settings/contact-support',
  path: '/settings/contact-support',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsBlockedUsersRoute = SettingsBlockedUsersRouteImport.update({
  id: '/settings/blocked-users',
  path: '/settings/blocked-users',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsArchiveRoute = SettingsArchiveRouteImport.update({
  id: '/settings/archive',
  path: '/settings/archive',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilesIdRoute = ProfilesIdRouteImport.update({
  id: '/profiles/$id',
  path: '/profiles/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIdRoute = ProductsIdRouteImport.update({
  id: '/products/$id',
  path: '/products/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LooksCreateRoute = LooksCreateRouteImport.update({
  id: '/looks/create',
  path: '/looks/create',
  getParentRoute: () => rootRouteImport,
} as any)
const LooksIdRoute = LooksIdRouteImport.update({
  id: '/looks/$id',
  path: '/looks/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CollectionsIdRoute = CollectionsIdRouteImport.update({
  id: '/collections/$id',
  path: '/collections/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPendingUsersRoute = AdminPendingUsersRouteImport.update({
  id: '/pending-users',
  path: '/pending-users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRouteRoute,
} as any)
const onboardingauthRouteRoute = onboardingauthRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => onboardingRouteRoute,
} as any)
const SettingsAccountIndexRoute = SettingsAccountIndexRouteImport.update({
  id: '/settings/account/',
  path: '/settings/account/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSubscriptionsPriceRoute =
  SettingsSubscriptionsPriceRouteImport.update({
    id: '/settings/subscriptions/price',
    path: '/settings/subscriptions/price',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsSubscriptionsManageRoute =
  SettingsSubscriptionsManageRouteImport.update({
    id: '/settings/subscriptions/manage',
    path: '/settings/subscriptions/manage',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsAccountChangePasswordRoute =
  SettingsAccountChangePasswordRouteImport.update({
    id: '/settings/account/change-password',
    path: '/settings/account/change-password',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProfilesIdSubscribersRoute = ProfilesIdSubscribersRouteImport.update({
  id: '/profiles_/$id/subscribers',
  path: '/profiles/$id/subscribers',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilesIdFollowingRoute = ProfilesIdFollowingRouteImport.update({
  id: '/profiles_/$id/following',
  path: '/profiles/$id/following',
  getParentRoute: () => rootRouteImport,
} as any)
const LooksIdEditRoute = LooksIdEditRouteImport.update({
  id: '/looks_/$id/edit',
  path: '/looks/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const CollectionsIdEditDetailsRoute =
  CollectionsIdEditDetailsRouteImport.update({
    id: '/collections_/$id/edit-details',
    path: '/collections/$id/edit-details',
    getParentRoute: () => rootRouteImport,
  } as any)
const CollectionsIdEditRoute = CollectionsIdEditRouteImport.update({
  id: '/collections_/$id/edit',
  path: '/collections/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const onboardingpricingPricingRoute =
  onboardingpricingPricingRouteImport.update({
    id: '/(pricing)/pricing',
    path: '/pricing',
    getParentRoute: () => onboardingRouteRoute,
  } as any)
const onboardingpricingCheckoutReturnRoute =
  onboardingpricingCheckoutReturnRouteImport.update({
    id: '/(pricing)/checkout-return',
    path: '/checkout-return',
    getParentRoute: () => onboardingRouteRoute,
  } as any)
const onboardingpricingCheckoutRoute =
  onboardingpricingCheckoutRouteImport.update({
    id: '/(pricing)/checkout',
    path: '/checkout',
    getParentRoute: () => onboardingRouteRoute,
  } as any)
const onboardingdocumentsTermsOfUseRoute =
  onboardingdocumentsTermsOfUseRouteImport.update({
    id: '/(documents)/terms-of-use',
    path: '/terms-of-use',
    getParentRoute: () => onboardingRouteRoute,
  } as any)
const onboardingdocumentsTermsAndConditionsRoute =
  onboardingdocumentsTermsAndConditionsRouteImport.update({
    id: '/(documents)/terms-and-conditions',
    path: '/terms-and-conditions',
    getParentRoute: () => onboardingRouteRoute,
  } as any)
const onboardingdocumentsSitemapRoute =
  onboardingdocumentsSitemapRouteImport.update({
    id: '/(documents)/sitemap',
    path: '/sitemap',
    getParentRoute: () => onboardingRouteRoute,
  } as any)
const onboardingdocumentsPrivacyPolicyRoute =
  onboardingdocumentsPrivacyPolicyRouteImport.update({
    id: '/(documents)/privacy-policy',
    path: '/privacy-policy',
    getParentRoute: () => onboardingRouteRoute,
  } as any)
const onboardingdocumentsExtensionPrivacyPolicyRoute =
  onboardingdocumentsExtensionPrivacyPolicyRouteImport.update({
    id: '/(documents)/extension-privacy-policy',
    path: '/extension-privacy-policy',
    getParentRoute: () => onboardingRouteRoute,
  } as any)
const onboardingauthVerifyEmailRoute =
  onboardingauthVerifyEmailRouteImport.update({
    id: '/verify-email',
    path: '/verify-email',
    getParentRoute: () => onboardingauthRouteRoute,
  } as any)
const onboardingauthResetPasswordRoute =
  onboardingauthResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => onboardingauthRouteRoute,
  } as any)
const onboardingauthOnboardingRoute =
  onboardingauthOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => onboardingauthRouteRoute,
  } as any)
const onboardingauthLogoutRoute = onboardingauthLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => onboardingauthRouteRoute,
} as any)
const onboardingauthLoginRoute = onboardingauthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => onboardingauthRouteRoute,
} as any)
const onboardingauthForgotPasswordRoute =
  onboardingauthForgotPasswordRouteImport.update({
    id: '/forgot-password_',
    path: '/forgot-password',
    getParentRoute: () => onboardingauthRouteRoute,
  } as any)
const onboardingauthActionRoute = onboardingauthActionRouteImport.update({
  id: '/action',
  path: '/action',
  getParentRoute: () => onboardingauthRouteRoute,
} as any)
const onboardingauthRegisterIndexRoute =
  onboardingauthRegisterIndexRouteImport.update({
    id: '/register/',
    path: '/register/',
    getParentRoute: () => onboardingauthRouteRoute,
  } as any)
const onboardingauthRegisterUsernameRoute =
  onboardingauthRegisterUsernameRouteImport.update({
    id: '/register/username',
    path: '/register/username',
    getParentRoute: () => onboardingauthRouteRoute,
  } as any)
const onboardingauthRegisterPreferencesRoute =
  onboardingauthRegisterPreferencesRouteImport.update({
    id: '/register/preferences',
    path: '/register/preferences',
    getParentRoute: () => onboardingauthRouteRoute,
  } as any)
const onboardingauthRegisterInstagramRoute =
  onboardingauthRegisterInstagramRouteImport.update({
    id: '/register/instagram',
    path: '/register/instagram',
    getParentRoute: () => onboardingauthRouteRoute,
  } as any)
const onboardingauthRegisterAccountTypeRoute =
  onboardingauthRegisterAccountTypeRouteImport.update({
    id: '/register/account-type',
    path: '/register/account-type',
    getParentRoute: () => onboardingauthRouteRoute,
  } as any)
const onboardingauthForgotPasswordSentRoute =
  onboardingauthForgotPasswordSentRouteImport.update({
    id: '/forgot-password/sent',
    path: '/forgot-password/sent',
    getParentRoute: () => onboardingauthRouteRoute,
  } as any)
const onboardingauthextensionExtensionAuthCheckRoute =
  onboardingauthextensionExtensionAuthCheckRouteImport.update({
    id: '/(extension)/extension-auth-check',
    path: '/extension-auth-check',
    getParentRoute: () => onboardingauthRouteRoute,
  } as any)
const onboardingauthextensionExtensionAuthCallbackRoute =
  onboardingauthextensionExtensionAuthCallbackRouteImport.update({
    id: '/(extension)/extension-auth-callback',
    path: '/extension-auth-callback',
    getParentRoute: () => onboardingauthRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/featured': typeof FeaturedRoute
  '/search': typeof SearchRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/pending-users': typeof AdminPendingUsersRoute
  '/admin/reports': typeof AdminReportsRoute
  '/collections/$id': typeof CollectionsIdRoute
  '/looks/$id': typeof LooksIdRoute
  '/looks/create': typeof LooksCreateRoute
  '/products/$id': typeof ProductsIdRoute
  '/profiles/$id': typeof ProfilesIdRoute
  '/settings/archive': typeof SettingsArchiveRoute
  '/settings/blocked-users': typeof SettingsBlockedUsersRoute
  '/settings/contact-support': typeof SettingsContactSupportRoute
  '/settings/dashboard': typeof SettingsDashboardRoute
  '/settings/feedback': typeof SettingsFeedbackRoute
  '/settings/wallet': typeof SettingsWalletRoute
  '/users/$id': typeof UsersIdRoute
  '/admin/': typeof AdminIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/action': typeof onboardingauthActionRoute
  '/forgot-password': typeof onboardingauthForgotPasswordRoute
  '/login': typeof onboardingauthLoginRoute
  '/logout': typeof onboardingauthLogoutRoute
  '/onboarding': typeof onboardingauthOnboardingRoute
  '/reset-password': typeof onboardingauthResetPasswordRoute
  '/verify-email': typeof onboardingauthVerifyEmailRoute
  '/extension-privacy-policy': typeof onboardingdocumentsExtensionPrivacyPolicyRoute
  '/privacy-policy': typeof onboardingdocumentsPrivacyPolicyRoute
  '/sitemap': typeof onboardingdocumentsSitemapRoute
  '/terms-and-conditions': typeof onboardingdocumentsTermsAndConditionsRoute
  '/terms-of-use': typeof onboardingdocumentsTermsOfUseRoute
  '/checkout': typeof onboardingpricingCheckoutRoute
  '/checkout-return': typeof onboardingpricingCheckoutReturnRoute
  '/pricing': typeof onboardingpricingPricingRoute
  '/collections/$id/edit': typeof CollectionsIdEditRoute
  '/collections/$id/edit-details': typeof CollectionsIdEditDetailsRoute
  '/looks/$id/edit': typeof LooksIdEditRoute
  '/profiles/$id/following': typeof ProfilesIdFollowingRoute
  '/profiles/$id/subscribers': typeof ProfilesIdSubscribersRoute
  '/settings/account/change-password': typeof SettingsAccountChangePasswordRoute
  '/settings/subscriptions/manage': typeof SettingsSubscriptionsManageRoute
  '/settings/subscriptions/price': typeof SettingsSubscriptionsPriceRoute
  '/settings/account': typeof SettingsAccountIndexRoute
  '/extension-auth-callback': typeof onboardingauthextensionExtensionAuthCallbackRoute
  '/extension-auth-check': typeof onboardingauthextensionExtensionAuthCheckRoute
  '/forgot-password/sent': typeof onboardingauthForgotPasswordSentRoute
  '/register/account-type': typeof onboardingauthRegisterAccountTypeRoute
  '/register/instagram': typeof onboardingauthRegisterInstagramRoute
  '/register/preferences': typeof onboardingauthRegisterPreferencesRoute
  '/register/username': typeof onboardingauthRegisterUsernameRoute
  '/register': typeof onboardingauthRegisterIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/featured': typeof FeaturedRoute
  '/search': typeof SearchRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/pending-users': typeof AdminPendingUsersRoute
  '/admin/reports': typeof AdminReportsRoute
  '/collections/$id': typeof CollectionsIdRoute
  '/looks/$id': typeof LooksIdRoute
  '/looks/create': typeof LooksCreateRoute
  '/products/$id': typeof ProductsIdRoute
  '/profiles/$id': typeof ProfilesIdRoute
  '/settings/archive': typeof SettingsArchiveRoute
  '/settings/blocked-users': typeof SettingsBlockedUsersRoute
  '/settings/contact-support': typeof SettingsContactSupportRoute
  '/settings/dashboard': typeof SettingsDashboardRoute
  '/settings/feedback': typeof SettingsFeedbackRoute
  '/settings/wallet': typeof SettingsWalletRoute
  '/users/$id': typeof UsersIdRoute
  '/admin': typeof AdminIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/action': typeof onboardingauthActionRoute
  '/forgot-password': typeof onboardingauthForgotPasswordRoute
  '/login': typeof onboardingauthLoginRoute
  '/logout': typeof onboardingauthLogoutRoute
  '/onboarding': typeof onboardingauthOnboardingRoute
  '/reset-password': typeof onboardingauthResetPasswordRoute
  '/verify-email': typeof onboardingauthVerifyEmailRoute
  '/extension-privacy-policy': typeof onboardingdocumentsExtensionPrivacyPolicyRoute
  '/privacy-policy': typeof onboardingdocumentsPrivacyPolicyRoute
  '/sitemap': typeof onboardingdocumentsSitemapRoute
  '/terms-and-conditions': typeof onboardingdocumentsTermsAndConditionsRoute
  '/terms-of-use': typeof onboardingdocumentsTermsOfUseRoute
  '/checkout': typeof onboardingpricingCheckoutRoute
  '/checkout-return': typeof onboardingpricingCheckoutReturnRoute
  '/pricing': typeof onboardingpricingPricingRoute
  '/collections/$id/edit': typeof CollectionsIdEditRoute
  '/collections/$id/edit-details': typeof CollectionsIdEditDetailsRoute
  '/looks/$id/edit': typeof LooksIdEditRoute
  '/profiles/$id/following': typeof ProfilesIdFollowingRoute
  '/profiles/$id/subscribers': typeof ProfilesIdSubscribersRoute
  '/settings/account/change-password': typeof SettingsAccountChangePasswordRoute
  '/settings/subscriptions/manage': typeof SettingsSubscriptionsManageRoute
  '/settings/subscriptions/price': typeof SettingsSubscriptionsPriceRoute
  '/settings/account': typeof SettingsAccountIndexRoute
  '/extension-auth-callback': typeof onboardingauthextensionExtensionAuthCallbackRoute
  '/extension-auth-check': typeof onboardingauthextensionExtensionAuthCheckRoute
  '/forgot-password/sent': typeof onboardingauthForgotPasswordSentRoute
  '/register/account-type': typeof onboardingauthRegisterAccountTypeRoute
  '/register/instagram': typeof onboardingauthRegisterInstagramRoute
  '/register/preferences': typeof onboardingauthRegisterPreferencesRoute
  '/register/username': typeof onboardingauthRegisterUsernameRoute
  '/register': typeof onboardingauthRegisterIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(onboarding)': typeof onboardingRouteRouteWithChildren
  '/admin': typeof AdminRouteRouteWithChildren
  '/featured': typeof FeaturedRoute
  '/search': typeof SearchRoute
  '/(onboarding)/(auth)': typeof onboardingauthRouteRouteWithChildren
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/pending-users': typeof AdminPendingUsersRoute
  '/admin/reports': typeof AdminReportsRoute
  '/collections/$id': typeof CollectionsIdRoute
  '/looks/$id': typeof LooksIdRoute
  '/looks/create': typeof LooksCreateRoute
  '/products/$id': typeof ProductsIdRoute
  '/profiles/$id': typeof ProfilesIdRoute
  '/settings/archive': typeof SettingsArchiveRoute
  '/settings/blocked-users': typeof SettingsBlockedUsersRoute
  '/settings/contact-support': typeof SettingsContactSupportRoute
  '/settings/dashboard': typeof SettingsDashboardRoute
  '/settings/feedback': typeof SettingsFeedbackRoute
  '/settings/wallet': typeof SettingsWalletRoute
  '/users/$id': typeof UsersIdRoute
  '/admin/': typeof AdminIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/(onboarding)/(auth)/action': typeof onboardingauthActionRoute
  '/(onboarding)/(auth)/forgot-password_': typeof onboardingauthForgotPasswordRoute
  '/(onboarding)/(auth)/login': typeof onboardingauthLoginRoute
  '/(onboarding)/(auth)/logout': typeof onboardingauthLogoutRoute
  '/(onboarding)/(auth)/onboarding': typeof onboardingauthOnboardingRoute
  '/(onboarding)/(auth)/reset-password': typeof onboardingauthResetPasswordRoute
  '/(onboarding)/(auth)/verify-email': typeof onboardingauthVerifyEmailRoute
  '/(onboarding)/(documents)/extension-privacy-policy': typeof onboardingdocumentsExtensionPrivacyPolicyRoute
  '/(onboarding)/(documents)/privacy-policy': typeof onboardingdocumentsPrivacyPolicyRoute
  '/(onboarding)/(documents)/sitemap': typeof onboardingdocumentsSitemapRoute
  '/(onboarding)/(documents)/terms-and-conditions': typeof onboardingdocumentsTermsAndConditionsRoute
  '/(onboarding)/(documents)/terms-of-use': typeof onboardingdocumentsTermsOfUseRoute
  '/(onboarding)/(pricing)/checkout': typeof onboardingpricingCheckoutRoute
  '/(onboarding)/(pricing)/checkout-return': typeof onboardingpricingCheckoutReturnRoute
  '/(onboarding)/(pricing)/pricing': typeof onboardingpricingPricingRoute
  '/collections_/$id/edit': typeof CollectionsIdEditRoute
  '/collections_/$id/edit-details': typeof CollectionsIdEditDetailsRoute
  '/looks_/$id/edit': typeof LooksIdEditRoute
  '/profiles_/$id/following': typeof ProfilesIdFollowingRoute
  '/profiles_/$id/subscribers': typeof ProfilesIdSubscribersRoute
  '/settings/account/change-password': typeof SettingsAccountChangePasswordRoute
  '/settings/subscriptions/manage': typeof SettingsSubscriptionsManageRoute
  '/settings/subscriptions/price': typeof SettingsSubscriptionsPriceRoute
  '/settings/account/': typeof SettingsAccountIndexRoute
  '/(onboarding)/(auth)/(extension)/extension-auth-callback': typeof onboardingauthextensionExtensionAuthCallbackRoute
  '/(onboarding)/(auth)/(extension)/extension-auth-check': typeof onboardingauthextensionExtensionAuthCheckRoute
  '/(onboarding)/(auth)/forgot-password/sent': typeof onboardingauthForgotPasswordSentRoute
  '/(onboarding)/(auth)/register/account-type': typeof onboardingauthRegisterAccountTypeRoute
  '/(onboarding)/(auth)/register/instagram': typeof onboardingauthRegisterInstagramRoute
  '/(onboarding)/(auth)/register/preferences': typeof onboardingauthRegisterPreferencesRoute
  '/(onboarding)/(auth)/register/username': typeof onboardingauthRegisterUsernameRoute
  '/(onboarding)/(auth)/register/': typeof onboardingauthRegisterIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/featured'
    | '/search'
    | '/admin/dashboard'
    | '/admin/pending-users'
    | '/admin/reports'
    | '/collections/$id'
    | '/looks/$id'
    | '/looks/create'
    | '/products/$id'
    | '/profiles/$id'
    | '/settings/archive'
    | '/settings/blocked-users'
    | '/settings/contact-support'
    | '/settings/dashboard'
    | '/settings/feedback'
    | '/settings/wallet'
    | '/users/$id'
    | '/admin/'
    | '/settings'
    | '/action'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/onboarding'
    | '/reset-password'
    | '/verify-email'
    | '/extension-privacy-policy'
    | '/privacy-policy'
    | '/sitemap'
    | '/terms-and-conditions'
    | '/terms-of-use'
    | '/checkout'
    | '/checkout-return'
    | '/pricing'
    | '/collections/$id/edit'
    | '/collections/$id/edit-details'
    | '/looks/$id/edit'
    | '/profiles/$id/following'
    | '/profiles/$id/subscribers'
    | '/settings/account/change-password'
    | '/settings/subscriptions/manage'
    | '/settings/subscriptions/price'
    | '/settings/account'
    | '/extension-auth-callback'
    | '/extension-auth-check'
    | '/forgot-password/sent'
    | '/register/account-type'
    | '/register/instagram'
    | '/register/preferences'
    | '/register/username'
    | '/register'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/featured'
    | '/search'
    | '/admin/dashboard'
    | '/admin/pending-users'
    | '/admin/reports'
    | '/collections/$id'
    | '/looks/$id'
    | '/looks/create'
    | '/products/$id'
    | '/profiles/$id'
    | '/settings/archive'
    | '/settings/blocked-users'
    | '/settings/contact-support'
    | '/settings/dashboard'
    | '/settings/feedback'
    | '/settings/wallet'
    | '/users/$id'
    | '/admin'
    | '/settings'
    | '/action'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/onboarding'
    | '/reset-password'
    | '/verify-email'
    | '/extension-privacy-policy'
    | '/privacy-policy'
    | '/sitemap'
    | '/terms-and-conditions'
    | '/terms-of-use'
    | '/checkout'
    | '/checkout-return'
    | '/pricing'
    | '/collections/$id/edit'
    | '/collections/$id/edit-details'
    | '/looks/$id/edit'
    | '/profiles/$id/following'
    | '/profiles/$id/subscribers'
    | '/settings/account/change-password'
    | '/settings/subscriptions/manage'
    | '/settings/subscriptions/price'
    | '/settings/account'
    | '/extension-auth-callback'
    | '/extension-auth-check'
    | '/forgot-password/sent'
    | '/register/account-type'
    | '/register/instagram'
    | '/register/preferences'
    | '/register/username'
    | '/register'
  id:
    | '__root__'
    | '/'
    | '/(onboarding)'
    | '/admin'
    | '/featured'
    | '/search'
    | '/(onboarding)/(auth)'
    | '/admin/dashboard'
    | '/admin/pending-users'
    | '/admin/reports'
    | '/collections/$id'
    | '/looks/$id'
    | '/looks/create'
    | '/products/$id'
    | '/profiles/$id'
    | '/settings/archive'
    | '/settings/blocked-users'
    | '/settings/contact-support'
    | '/settings/dashboard'
    | '/settings/feedback'
    | '/settings/wallet'
    | '/users/$id'
    | '/admin/'
    | '/settings/'
    | '/(onboarding)/(auth)/action'
    | '/(onboarding)/(auth)/forgot-password_'
    | '/(onboarding)/(auth)/login'
    | '/(onboarding)/(auth)/logout'
    | '/(onboarding)/(auth)/onboarding'
    | '/(onboarding)/(auth)/reset-password'
    | '/(onboarding)/(auth)/verify-email'
    | '/(onboarding)/(documents)/extension-privacy-policy'
    | '/(onboarding)/(documents)/privacy-policy'
    | '/(onboarding)/(documents)/sitemap'
    | '/(onboarding)/(documents)/terms-and-conditions'
    | '/(onboarding)/(documents)/terms-of-use'
    | '/(onboarding)/(pricing)/checkout'
    | '/(onboarding)/(pricing)/checkout-return'
    | '/(onboarding)/(pricing)/pricing'
    | '/collections_/$id/edit'
    | '/collections_/$id/edit-details'
    | '/looks_/$id/edit'
    | '/profiles_/$id/following'
    | '/profiles_/$id/subscribers'
    | '/settings/account/change-password'
    | '/settings/subscriptions/manage'
    | '/settings/subscriptions/price'
    | '/settings/account/'
    | '/(onboarding)/(auth)/(extension)/extension-auth-callback'
    | '/(onboarding)/(auth)/(extension)/extension-auth-check'
    | '/(onboarding)/(auth)/forgot-password/sent'
    | '/(onboarding)/(auth)/register/account-type'
    | '/(onboarding)/(auth)/register/instagram'
    | '/(onboarding)/(auth)/register/preferences'
    | '/(onboarding)/(auth)/register/username'
    | '/(onboarding)/(auth)/register/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  onboardingRouteRoute: typeof onboardingRouteRouteWithChildren
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  FeaturedRoute: typeof FeaturedRoute
  SearchRoute: typeof SearchRoute
  CollectionsIdRoute: typeof CollectionsIdRoute
  LooksIdRoute: typeof LooksIdRoute
  LooksCreateRoute: typeof LooksCreateRoute
  ProductsIdRoute: typeof ProductsIdRoute
  ProfilesIdRoute: typeof ProfilesIdRoute
  SettingsArchiveRoute: typeof SettingsArchiveRoute
  SettingsBlockedUsersRoute: typeof SettingsBlockedUsersRoute
  SettingsContactSupportRoute: typeof SettingsContactSupportRoute
  SettingsDashboardRoute: typeof SettingsDashboardRoute
  SettingsFeedbackRoute: typeof SettingsFeedbackRoute
  SettingsWalletRoute: typeof SettingsWalletRoute
  UsersIdRoute: typeof UsersIdRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  CollectionsIdEditRoute: typeof CollectionsIdEditRoute
  CollectionsIdEditDetailsRoute: typeof CollectionsIdEditDetailsRoute
  LooksIdEditRoute: typeof LooksIdEditRoute
  ProfilesIdFollowingRoute: typeof ProfilesIdFollowingRoute
  ProfilesIdSubscribersRoute: typeof ProfilesIdSubscribersRoute
  SettingsAccountChangePasswordRoute: typeof SettingsAccountChangePasswordRoute
  SettingsSubscriptionsManageRoute: typeof SettingsSubscriptionsManageRoute
  SettingsSubscriptionsPriceRoute: typeof SettingsSubscriptionsPriceRoute
  SettingsAccountIndexRoute: typeof SettingsAccountIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/featured': {
      id: '/featured'
      path: '/featured'
      fullPath: '/featured'
      preLoaderRoute: typeof FeaturedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(onboarding)': {
      id: '/(onboarding)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof onboardingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/users/$id': {
      id: '/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof UsersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/wallet': {
      id: '/settings/wallet'
      path: '/settings/wallet'
      fullPath: '/settings/wallet'
      preLoaderRoute: typeof SettingsWalletRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/feedback': {
      id: '/settings/feedback'
      path: '/settings/feedback'
      fullPath: '/settings/feedback'
      preLoaderRoute: typeof SettingsFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/dashboard': {
      id: '/settings/dashboard'
      path: '/settings/dashboard'
      fullPath: '/settings/dashboard'
      preLoaderRoute: typeof SettingsDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/contact-support': {
      id: '/settings/contact-support'
      path: '/settings/contact-support'
      fullPath: '/settings/contact-support'
      preLoaderRoute: typeof SettingsContactSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/blocked-users': {
      id: '/settings/blocked-users'
      path: '/settings/blocked-users'
      fullPath: '/settings/blocked-users'
      preLoaderRoute: typeof SettingsBlockedUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/archive': {
      id: '/settings/archive'
      path: '/settings/archive'
      fullPath: '/settings/archive'
      preLoaderRoute: typeof SettingsArchiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profiles/$id': {
      id: '/profiles/$id'
      path: '/profiles/$id'
      fullPath: '/profiles/$id'
      preLoaderRoute: typeof ProfilesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/$id': {
      id: '/products/$id'
      path: '/products/$id'
      fullPath: '/products/$id'
      preLoaderRoute: typeof ProductsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/looks/create': {
      id: '/looks/create'
      path: '/looks/create'
      fullPath: '/looks/create'
      preLoaderRoute: typeof LooksCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/looks/$id': {
      id: '/looks/$id'
      path: '/looks/$id'
      fullPath: '/looks/$id'
      preLoaderRoute: typeof LooksIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/$id': {
      id: '/collections/$id'
      path: '/collections/$id'
      fullPath: '/collections/$id'
      preLoaderRoute: typeof CollectionsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pending-users': {
      id: '/admin/pending-users'
      path: '/pending-users'
      fullPath: '/admin/pending-users'
      preLoaderRoute: typeof AdminPendingUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/(onboarding)/(auth)': {
      id: '/(onboarding)/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof onboardingauthRouteRouteImport
      parentRoute: typeof onboardingRouteRoute
    }
    '/settings/account/': {
      id: '/settings/account/'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/subscriptions/price': {
      id: '/settings/subscriptions/price'
      path: '/settings/subscriptions/price'
      fullPath: '/settings/subscriptions/price'
      preLoaderRoute: typeof SettingsSubscriptionsPriceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/subscriptions/manage': {
      id: '/settings/subscriptions/manage'
      path: '/settings/subscriptions/manage'
      fullPath: '/settings/subscriptions/manage'
      preLoaderRoute: typeof SettingsSubscriptionsManageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/account/change-password': {
      id: '/settings/account/change-password'
      path: '/settings/account/change-password'
      fullPath: '/settings/account/change-password'
      preLoaderRoute: typeof SettingsAccountChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profiles_/$id/subscribers': {
      id: '/profiles_/$id/subscribers'
      path: '/profiles/$id/subscribers'
      fullPath: '/profiles/$id/subscribers'
      preLoaderRoute: typeof ProfilesIdSubscribersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profiles_/$id/following': {
      id: '/profiles_/$id/following'
      path: '/profiles/$id/following'
      fullPath: '/profiles/$id/following'
      preLoaderRoute: typeof ProfilesIdFollowingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/looks_/$id/edit': {
      id: '/looks_/$id/edit'
      path: '/looks/$id/edit'
      fullPath: '/looks/$id/edit'
      preLoaderRoute: typeof LooksIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections_/$id/edit-details': {
      id: '/collections_/$id/edit-details'
      path: '/collections/$id/edit-details'
      fullPath: '/collections/$id/edit-details'
      preLoaderRoute: typeof CollectionsIdEditDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections_/$id/edit': {
      id: '/collections_/$id/edit'
      path: '/collections/$id/edit'
      fullPath: '/collections/$id/edit'
      preLoaderRoute: typeof CollectionsIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(onboarding)/(pricing)/pricing': {
      id: '/(onboarding)/(pricing)/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof onboardingpricingPricingRouteImport
      parentRoute: typeof onboardingRouteRoute
    }
    '/(onboarding)/(pricing)/checkout-return': {
      id: '/(onboarding)/(pricing)/checkout-return'
      path: '/checkout-return'
      fullPath: '/checkout-return'
      preLoaderRoute: typeof onboardingpricingCheckoutReturnRouteImport
      parentRoute: typeof onboardingRouteRoute
    }
    '/(onboarding)/(pricing)/checkout': {
      id: '/(onboarding)/(pricing)/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof onboardingpricingCheckoutRouteImport
      parentRoute: typeof onboardingRouteRoute
    }
    '/(onboarding)/(documents)/terms-of-use': {
      id: '/(onboarding)/(documents)/terms-of-use'
      path: '/terms-of-use'
      fullPath: '/terms-of-use'
      preLoaderRoute: typeof onboardingdocumentsTermsOfUseRouteImport
      parentRoute: typeof onboardingRouteRoute
    }
    '/(onboarding)/(documents)/terms-and-conditions': {
      id: '/(onboarding)/(documents)/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof onboardingdocumentsTermsAndConditionsRouteImport
      parentRoute: typeof onboardingRouteRoute
    }
    '/(onboarding)/(documents)/sitemap': {
      id: '/(onboarding)/(documents)/sitemap'
      path: '/sitemap'
      fullPath: '/sitemap'
      preLoaderRoute: typeof onboardingdocumentsSitemapRouteImport
      parentRoute: typeof onboardingRouteRoute
    }
    '/(onboarding)/(documents)/privacy-policy': {
      id: '/(onboarding)/(documents)/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof onboardingdocumentsPrivacyPolicyRouteImport
      parentRoute: typeof onboardingRouteRoute
    }
    '/(onboarding)/(documents)/extension-privacy-policy': {
      id: '/(onboarding)/(documents)/extension-privacy-policy'
      path: '/extension-privacy-policy'
      fullPath: '/extension-privacy-policy'
      preLoaderRoute: typeof onboardingdocumentsExtensionPrivacyPolicyRouteImport
      parentRoute: typeof onboardingRouteRoute
    }
    '/(onboarding)/(auth)/verify-email': {
      id: '/(onboarding)/(auth)/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof onboardingauthVerifyEmailRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
    '/(onboarding)/(auth)/reset-password': {
      id: '/(onboarding)/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof onboardingauthResetPasswordRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
    '/(onboarding)/(auth)/onboarding': {
      id: '/(onboarding)/(auth)/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof onboardingauthOnboardingRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
    '/(onboarding)/(auth)/logout': {
      id: '/(onboarding)/(auth)/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof onboardingauthLogoutRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
    '/(onboarding)/(auth)/login': {
      id: '/(onboarding)/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof onboardingauthLoginRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
    '/(onboarding)/(auth)/forgot-password_': {
      id: '/(onboarding)/(auth)/forgot-password_'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof onboardingauthForgotPasswordRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
    '/(onboarding)/(auth)/action': {
      id: '/(onboarding)/(auth)/action'
      path: '/action'
      fullPath: '/action'
      preLoaderRoute: typeof onboardingauthActionRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
    '/(onboarding)/(auth)/register/': {
      id: '/(onboarding)/(auth)/register/'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof onboardingauthRegisterIndexRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
    '/(onboarding)/(auth)/register/username': {
      id: '/(onboarding)/(auth)/register/username'
      path: '/register/username'
      fullPath: '/register/username'
      preLoaderRoute: typeof onboardingauthRegisterUsernameRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
    '/(onboarding)/(auth)/register/preferences': {
      id: '/(onboarding)/(auth)/register/preferences'
      path: '/register/preferences'
      fullPath: '/register/preferences'
      preLoaderRoute: typeof onboardingauthRegisterPreferencesRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
    '/(onboarding)/(auth)/register/instagram': {
      id: '/(onboarding)/(auth)/register/instagram'
      path: '/register/instagram'
      fullPath: '/register/instagram'
      preLoaderRoute: typeof onboardingauthRegisterInstagramRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
    '/(onboarding)/(auth)/register/account-type': {
      id: '/(onboarding)/(auth)/register/account-type'
      path: '/register/account-type'
      fullPath: '/register/account-type'
      preLoaderRoute: typeof onboardingauthRegisterAccountTypeRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
    '/(onboarding)/(auth)/forgot-password/sent': {
      id: '/(onboarding)/(auth)/forgot-password/sent'
      path: '/forgot-password/sent'
      fullPath: '/forgot-password/sent'
      preLoaderRoute: typeof onboardingauthForgotPasswordSentRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
    '/(onboarding)/(auth)/(extension)/extension-auth-check': {
      id: '/(onboarding)/(auth)/(extension)/extension-auth-check'
      path: '/extension-auth-check'
      fullPath: '/extension-auth-check'
      preLoaderRoute: typeof onboardingauthextensionExtensionAuthCheckRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
    '/(onboarding)/(auth)/(extension)/extension-auth-callback': {
      id: '/(onboarding)/(auth)/(extension)/extension-auth-callback'
      path: '/extension-auth-callback'
      fullPath: '/extension-auth-callback'
      preLoaderRoute: typeof onboardingauthextensionExtensionAuthCallbackRouteImport
      parentRoute: typeof onboardingauthRouteRoute
    }
  }
}

interface onboardingauthRouteRouteChildren {
  onboardingauthActionRoute: typeof onboardingauthActionRoute
  onboardingauthForgotPasswordRoute: typeof onboardingauthForgotPasswordRoute
  onboardingauthLoginRoute: typeof onboardingauthLoginRoute
  onboardingauthLogoutRoute: typeof onboardingauthLogoutRoute
  onboardingauthOnboardingRoute: typeof onboardingauthOnboardingRoute
  onboardingauthResetPasswordRoute: typeof onboardingauthResetPasswordRoute
  onboardingauthVerifyEmailRoute: typeof onboardingauthVerifyEmailRoute
  onboardingauthextensionExtensionAuthCallbackRoute: typeof onboardingauthextensionExtensionAuthCallbackRoute
  onboardingauthextensionExtensionAuthCheckRoute: typeof onboardingauthextensionExtensionAuthCheckRoute
  onboardingauthForgotPasswordSentRoute: typeof onboardingauthForgotPasswordSentRoute
  onboardingauthRegisterAccountTypeRoute: typeof onboardingauthRegisterAccountTypeRoute
  onboardingauthRegisterInstagramRoute: typeof onboardingauthRegisterInstagramRoute
  onboardingauthRegisterPreferencesRoute: typeof onboardingauthRegisterPreferencesRoute
  onboardingauthRegisterUsernameRoute: typeof onboardingauthRegisterUsernameRoute
  onboardingauthRegisterIndexRoute: typeof onboardingauthRegisterIndexRoute
}

const onboardingauthRouteRouteChildren: onboardingauthRouteRouteChildren = {
  onboardingauthActionRoute: onboardingauthActionRoute,
  onboardingauthForgotPasswordRoute: onboardingauthForgotPasswordRoute,
  onboardingauthLoginRoute: onboardingauthLoginRoute,
  onboardingauthLogoutRoute: onboardingauthLogoutRoute,
  onboardingauthOnboardingRoute: onboardingauthOnboardingRoute,
  onboardingauthResetPasswordRoute: onboardingauthResetPasswordRoute,
  onboardingauthVerifyEmailRoute: onboardingauthVerifyEmailRoute,
  onboardingauthextensionExtensionAuthCallbackRoute:
    onboardingauthextensionExtensionAuthCallbackRoute,
  onboardingauthextensionExtensionAuthCheckRoute:
    onboardingauthextensionExtensionAuthCheckRoute,
  onboardingauthForgotPasswordSentRoute: onboardingauthForgotPasswordSentRoute,
  onboardingauthRegisterAccountTypeRoute:
    onboardingauthRegisterAccountTypeRoute,
  onboardingauthRegisterInstagramRoute: onboardingauthRegisterInstagramRoute,
  onboardingauthRegisterPreferencesRoute:
    onboardingauthRegisterPreferencesRoute,
  onboardingauthRegisterUsernameRoute: onboardingauthRegisterUsernameRoute,
  onboardingauthRegisterIndexRoute: onboardingauthRegisterIndexRoute,
}

const onboardingauthRouteRouteWithChildren =
  onboardingauthRouteRoute._addFileChildren(onboardingauthRouteRouteChildren)

interface onboardingRouteRouteChildren {
  onboardingauthRouteRoute: typeof onboardingauthRouteRouteWithChildren
  onboardingdocumentsExtensionPrivacyPolicyRoute: typeof onboardingdocumentsExtensionPrivacyPolicyRoute
  onboardingdocumentsPrivacyPolicyRoute: typeof onboardingdocumentsPrivacyPolicyRoute
  onboardingdocumentsSitemapRoute: typeof onboardingdocumentsSitemapRoute
  onboardingdocumentsTermsAndConditionsRoute: typeof onboardingdocumentsTermsAndConditionsRoute
  onboardingdocumentsTermsOfUseRoute: typeof onboardingdocumentsTermsOfUseRoute
  onboardingpricingCheckoutRoute: typeof onboardingpricingCheckoutRoute
  onboardingpricingCheckoutReturnRoute: typeof onboardingpricingCheckoutReturnRoute
  onboardingpricingPricingRoute: typeof onboardingpricingPricingRoute
}

const onboardingRouteRouteChildren: onboardingRouteRouteChildren = {
  onboardingauthRouteRoute: onboardingauthRouteRouteWithChildren,
  onboardingdocumentsExtensionPrivacyPolicyRoute:
    onboardingdocumentsExtensionPrivacyPolicyRoute,
  onboardingdocumentsPrivacyPolicyRoute: onboardingdocumentsPrivacyPolicyRoute,
  onboardingdocumentsSitemapRoute: onboardingdocumentsSitemapRoute,
  onboardingdocumentsTermsAndConditionsRoute:
    onboardingdocumentsTermsAndConditionsRoute,
  onboardingdocumentsTermsOfUseRoute: onboardingdocumentsTermsOfUseRoute,
  onboardingpricingCheckoutRoute: onboardingpricingCheckoutRoute,
  onboardingpricingCheckoutReturnRoute: onboardingpricingCheckoutReturnRoute,
  onboardingpricingPricingRoute: onboardingpricingPricingRoute,
}

const onboardingRouteRouteWithChildren = onboardingRouteRoute._addFileChildren(
  onboardingRouteRouteChildren,
)

interface AdminRouteRouteChildren {
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminPendingUsersRoute: typeof AdminPendingUsersRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminDashboardRoute: AdminDashboardRoute,
  AdminPendingUsersRoute: AdminPendingUsersRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  onboardingRouteRoute: onboardingRouteRouteWithChildren,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  FeaturedRoute: FeaturedRoute,
  SearchRoute: SearchRoute,
  CollectionsIdRoute: CollectionsIdRoute,
  LooksIdRoute: LooksIdRoute,
  LooksCreateRoute: LooksCreateRoute,
  ProductsIdRoute: ProductsIdRoute,
  ProfilesIdRoute: ProfilesIdRoute,
  SettingsArchiveRoute: SettingsArchiveRoute,
  SettingsBlockedUsersRoute: SettingsBlockedUsersRoute,
  SettingsContactSupportRoute: SettingsContactSupportRoute,
  SettingsDashboardRoute: SettingsDashboardRoute,
  SettingsFeedbackRoute: SettingsFeedbackRoute,
  SettingsWalletRoute: SettingsWalletRoute,
  UsersIdRoute: UsersIdRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  CollectionsIdEditRoute: CollectionsIdEditRoute,
  CollectionsIdEditDetailsRoute: CollectionsIdEditDetailsRoute,
  LooksIdEditRoute: LooksIdEditRoute,
  ProfilesIdFollowingRoute: ProfilesIdFollowingRoute,
  ProfilesIdSubscribersRoute: ProfilesIdSubscribersRoute,
  SettingsAccountChangePasswordRoute: SettingsAccountChangePasswordRoute,
  SettingsSubscriptionsManageRoute: SettingsSubscriptionsManageRoute,
  SettingsSubscriptionsPriceRoute: SettingsSubscriptionsPriceRoute,
  SettingsAccountIndexRoute: SettingsAccountIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
